import * as React from "react";

import { ILeanSvgIconWithColor } from "../ILeanSvgIconWithColor";

export const face_smiling_small: React.FunctionComponent<ILeanSvgIconWithColor> = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
      <path
        fill="none"
        stroke="currentColor"
        d="M20.5,12.0002 C20.5,16.7462 16.746,20.5002 12,20.5002 C7.254,20.5002 3.5,16.7462 3.5,12.0002 C3.5,7.2532 7.254,3.5002 12,3.5002 C16.746,3.5002 20.5,7.2532 20.5,12.0002 Z M7.4468,14.4997 C8.2088,16.2697 9.9288,17.4997 11.9998,17.4997 C14.0718,17.4997 15.7908,16.2697 16.5528,14.4997 M9,8.5 C8.724,8.5 8.5,8.724 8.5,9 C8.5,9.276 8.724,9.5 9,9.5 C9.276,9.5 9.5,9.276 9.5,9 C9.5,8.724 9.276,8.5 9,8.5 M15,8.5 C14.724,8.5 14.5,8.724 14.5,9 C14.5,9.276 14.724,9.5 15,9.5 C15.276,9.5 15.5,9.276 15.5,9 C15.5,8.724 15.276,8.5 15,8.5"
      />
    </svg>
  );
};
